var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7375 9.40529C31.816 8.24597 30.426 7.47568 28.8538 7.3801C28.5845 3.81195 25.6063 1 21.9692 1C19.4042 1 17.1674 2.39938 15.9763 4.47523C15.5102 4.34352 15.019 4.27159 14.5108 4.27159C12.2931 4.27159 10.3893 5.61357 9.56563 7.52945C9.14735 7.4251 8.70995 7.36894 8.25935 7.36894C5.28751 7.36894 2.87842 9.77812 2.87842 12.7499C2.87842 15.7216 5.28751 18.1308 8.25935 18.1308H28.5226C29.9456 18.1308 31.2396 17.5784 32.2018 16.6764",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98321 28.5137H3.01465C1.902 28.5137 1 29.4157 1 30.5283V42.5676C1 43.6802 1.902 44.5822 3.01465 44.5822H8.98321C10.0959 44.5822 10.9979 43.6802 10.9979 42.5676V30.5283C10.9979 29.4157 10.0959 28.5137 8.98321 28.5137Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18115 32.2217H10.817",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.817 40.873H1.18115",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7856 40.3646H24.7794C23.5564 40.3646 22.5649 39.3731 22.5649 38.1501V30.7282C22.5649 29.5051 23.5564 28.5137 24.7794 28.5137H36.7856C38.0087 28.5137 39.0001 29.5051 39.0001 30.7282V38.1501C39.0001 39.3731 38.0087 40.3646 36.7856 40.3646Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4523 36.6455H23.1128",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3185 40.3652H28.2466V44.5828H33.3185V40.3652Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8433 44.582H26.7217",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 28.2285V25.4597C5.99902 25.0213 6.3195 24.6488 6.75301 24.5834L14.6816 23.3861C15.115 23.3207 15.4356 22.9482 15.4356 22.5098V18.502",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7832 28.2285V25.4597C30.7832 25.0213 30.4627 24.6488 30.0292 24.5834L22.1007 23.3861C21.6672 23.3207 21.3467 22.9482 21.3467 22.5098V18.502",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9034,
    cy: 13.1836,
    r: 0.885793,
    fill: "#EB2019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTechnology);
export default __webpack_public_path__ + "static/media/icon-technology.98321f731dc6f801cdfaa62cdbbfd6ae.svg";
export { ForwardRef as ReactComponent };